export default {
  root: {
    borderCollapse: 'separate',
    borderSpacing: '0 10px'
  }
};
